import React, { useState } from 'react';
import { TextField, Button, Box } from '@mui/material';
import { Coordinate } from 'ol/coordinate';

interface CoordinateInputProps {
  onSave: (coords: Coordinate) => void;
}

const CoordinateInput: React.FC<CoordinateInputProps> = ({ onSave }) => {
  const [lat, setLat] = useState<string>('');
  const [lon, setLon] = useState<string>('');
  const [errorLat, setErrorLat] = useState<boolean>(false);
  const [errorLon, setErrorLon] = useState<boolean>(false);

  const handleSave = () => {
    const latNum = parseFloat(lat);
    const lonNum = parseFloat(lon);

    const isLatValid = !isNaN(latNum) && latNum >= -90 && latNum <= 90;
    const isLonValid = !isNaN(lonNum) && lonNum >= -180 && lonNum <= 180;

    setErrorLat(!isLatValid);
    setErrorLon(!isLonValid);

    if (isLatValid && isLonValid) {
      onSave([lonNum, latNum]); // Notice: [longitude, latitude] order for Coordinate
    }
  };

  return (
    <Box display="flex" alignItems="center" style={{ gap: 6, paddingTop: 4, paddingBottom: 4, flexShrink: 0 }}>
      <TextField
        value={lat}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLat(e.target.value)}
        placeholder="Latitude"
        variant="outlined"
        size="small"
        style={{ width: 110, flexShrink: 0 }}
        error={errorLat}
        helperText={errorLat ? 'Lat -90 to 90' : ''}
        onKeyDown={(e) => e.key === 'Enter' && handleSave()}
        InputProps={{
          style: { height: 32, padding: '0 8px' },
        }}
        inputProps={{
          style: { padding: '6px 8px' },
        }}
      />
      <TextField
        value={lon}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLon(e.target.value)}
        placeholder="Longitude"
        variant="outlined"
        size="small"
        style={{ width: 110, height: 30, flexShrink: 0 }}
        error={errorLon}
        helperText={errorLon ? 'Lon -180 to 180' : ''}
        onKeyDown={(e) => e.key === 'Enter' && handleSave()}
        InputProps={{
          style: { height: 32, padding: '0 8px' },
        }}
        inputProps={{
          style: { padding: '6px 8px' },
        }}
      />
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleSave}
        style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
      >
        Set Lat/Lon
      </Button>
    </Box>
  );
};

export default CoordinateInput;
